import React from "react";
import { Slider } from "../components";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";

export function SliderContainer({ children }) {
  return (
    <Slider>
      <Slider.Heading>Proudly installed at</Slider.Heading>
      <Slider.Line />
      <Slider.ImageSwiper>
        <Carousel autoPlay="true" infiniteLoop="true">
          <div>
            <img
              alt="abc"
              src="/images/vmsphotos/livePhoto6.jpeg"
              style={{
                height: "600px",
                width: "100%",
                objectFit: "cover",
                objectPosition: "center 0px",
              }}
            />
          </div>
          <div>
            <img
              alt="abc"
              src="/images/vmsphotos/livePhoto1.png"
              style={{
                height: "600px",
                width: "100%",
                objectFit: "cover",
                objectPosition: "center 0px",
              }}
            />
          </div>
          <div>
            <img
              alt="abc"
              src="/images/vmsphotos/livePhoto2.jpeg"
              style={{
                height: "600px",
                width: "100%",
                objectFit: "cover",
                objectPosition: "center 0px",
              }}
            />
          </div>
          <div>
            <img
              alt="abc"
              src="/images/vmsphotos/livePhoto3.jpeg"
              style={{
                height: "600px",
                width: "100%",
                objectFit: "cover",
                objectPosition: "center 0px",
              }}
            />
          </div>
          <div>
            <img
              alt="abc"
              src="/images/vmsphotos/livePhoto4.jpeg"
              style={{
                height: "600px",
                width: "100%",
                objectFit: "cover",
                objectPosition: "center 0px",
              }}
            />
          </div>
          <div>
            <img
              alt="abc"
              src="/images/vmsphotos/livePhoto5.jpeg"
              style={{
                height: "600px",
                width: "100%",
                objectFit: "cover",
                objectPosition: "center 0px",
              }}
            />
          </div>
        </Carousel>
      </Slider.ImageSwiper>
      {children}
    </Slider>
  );
}
